import script from "./PdfViewerNutrient.vue?vue&type=script&setup=true&lang=ts"
export * from "./PdfViewerNutrient.vue?vue&type=script&setup=true&lang=ts"

import "./PdfViewerNutrient.vue?vue&type=style&index=0&id=10a51ce4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10a51ce4"]])

export default __exports__